import { PremierServiceScheduleDTO } from "../DTO/premierServiceScheduleDTO";

export class PremierServiceSchedule{
    public id!: number;
    public added!: Date;
    public customerPremierPartnerServiceConfigurationId!: number;
    public moovStepPremierServiceConfigurationId!: number;
    public customerId!: number;
    public clientId!: number;
    public executeOnOrAfter!: Date;
    public startedAt!: Date;
    public finishedAt!: Date;
    public recurring!: boolean;
    public inProgress!: boolean;
    public finished!: boolean;
    public addedByUserId!: number;
    public optionalParameters!: OptionalParameter[];

    constructor(){
        this.optionalParameters=new Array();
    }

    public static mapFromDTO(param:PremierServiceScheduleDTO):PremierServiceSchedule{
        if(!param) throw new Error("parameter is null")
        let obj = new PremierServiceSchedule();
        try
        {
            obj.id = param.id;
            if(param.added)obj.added = new Date(param.added);
            obj.customerPremierPartnerServiceConfigurationId = param.customerPremierPartnerServiceConfigurationId;
            obj.moovStepPremierServiceConfigurationId = param.moovStepPremierServiceConfigurationId;
            obj.customerId = param.customerId;
            obj.clientId = param.clientId;
            obj.executeOnOrAfter = new Date(param.executeOnOrAfter);
            if(param.startedAt)obj.startedAt = new Date(param.startedAt);
            if(param.finishedAt)obj.finishedAt = new Date(param.finishedAt);
            obj.recurring = param.recurring;
            obj.inProgress = param.inProgress;
            obj.finished = param.finished;
            obj.addedByUserId = param.addedByUserId;
            if(param.optionalParameters)obj.optionalParameters = JSON.parse(param.optionalParameters);
            
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:PremierServiceSchedule):PremierServiceScheduleDTO{
        if(!param) throw new Error("parameter is null")
        let dto = new PremierServiceScheduleDTO();
        try
        {
            dto.id = param.id;
            if(param.added)dto.added = param.added.toISOString();
            dto.customerPremierPartnerServiceConfigurationId = param.customerPremierPartnerServiceConfigurationId;
            dto.moovStepPremierServiceConfigurationId = param.moovStepPremierServiceConfigurationId;
            dto.customerId = param.customerId;
            dto.clientId = param.clientId;
            dto.executeOnOrAfter = param.executeOnOrAfter.toISOString();
            if(param.startedAt)dto.startedAt = param.startedAt.toISOString();
            if(param.finishedAt)dto.finishedAt = param.finishedAt.toISOString();
            dto.recurring = param.recurring;
            dto.inProgress = param.inProgress;
            dto.finished = param.finished;
            dto.addedByUserId = param.addedByUserId;
            dto.optionalParameters = JSON.stringify(param.optionalParameters);
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    get canExecuteNow(){
        return !this.finished && !this.inProgress && (this.executeOnOrAfter.getTime()>(new Date()).getTime());
    }
    
}

export interface OptionalParameter{
    name:string;
    value:string;
}
